import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const ApprovalNoteDialog = ({ visible, onHide, onConfirm, count, isApproveAll = false }) => {
    const { th } = useLanguage();
    const [note, setNote] = useState('');

    useEffect(() => {
        if (visible) setNote('');
    }, [visible]);

    const headerText = isApproveAll
        ? th('invoiceApproval.confirmations.approveAllHeader')
        : th('invoiceApproval.confirmations.approveSelectedHeader');

    const messageText = isApproveAll
        ? th('invoiceApproval.confirmations.approveAll').replace('{count}', count)
        : th('invoiceApproval.confirmations.approveSelected').replace('{count}', count);

    const isNoteEmpty = !note || !note.trim();

    const footer = (
        <div className="flex justify-content-end gap-2">
            <Button
                label={th('common.cancel')}
                icon="pi pi-times"
                onClick={onHide}
                className="p-button-outlined p-button-secondary"
            />
            <Button
                label={th('common.confirm')}
                icon="pi pi-check"
                onClick={() => onConfirm(note.trim())}
                className="p-button-success"
                disabled={isNoteEmpty}
            />
        </div>
    );

    return (
        <Dialog
            header={headerText}
            visible={visible}
            style={{ width: '500px' }}
            breakpoints={{ '641px': '95vw' }}
            modal
            footer={footer}
            onHide={onHide}
        >
            <div className="flex flex-column gap-3">
                <div className="flex align-items-center gap-2">
                    <i className="pi pi-exclamation-triangle text-yellow-500 text-2xl"></i>
                    <span>{messageText}</span>
                </div>

                <div className="flex flex-column gap-2">
                    <label htmlFor="approvalNote" className="font-medium">
                        {th('invoiceApproval.confirmations.noteLabel')} <span className="text-red-500">*</span>
                    </label>
                    <InputTextarea
                        id="approvalNote"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        rows={4}
                        placeholder={th('invoiceApproval.confirmations.notePlaceholder')}
                        className={`w-full ${isNoteEmpty && note !== '' ? 'p-invalid' : ''}`}
                        autoResize
                        maxLength={500}
                    />
                    {isNoteEmpty && note !== '' && (
                        <small className="text-red-500">
                            {th('invoiceApproval.confirmations.noteRequired')}
                        </small>
                    )}
                    <small className="text-gray-500">
                        {th('invoiceApproval.confirmations.noteHelp')}
                    </small>
                </div>
            </div>
        </Dialog>
    );
};

export default ApprovalNoteDialog;
